import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import {axiosBaseUrl} from './config/webConfig'

Vue.use(ElementUI)

//配置axios的基础路径
axios.defaults.baseURL = axiosBaseUrl
//配置aixos配置全局属性
Vue.prototype.$http = axios;
// request请求拦截器
axios.interceptors.request.use(config => {
    //设置请求头  key   =  value
    // config.headers['application'] = "front";
    //配置语雀token
   // config.headers['X-Auth-Token'] = yuqueToken;
    return config;
}, error => {
    console.log('request拦截器 - 发生异常：');
    console.log(error);
});

Vue.config.productionTip = false


new Vue({
    router,
    render: h => h(App),
}).$mount('#app')


